<app-provider-call-log-form [provider]="provider" [office]="office" (newProviderCallLog)="onNewCallLog()" />
<div class="row ms-3 m-2">
  <h4>Outbound Call Logs</h4>
</div>
@if (providerCallLogs.length > 0) {
  <div>
    @if (!refreshing) {
      <div class="m-2">
        <div class="m-2">
          <app-pagination-header [paging]="paging" [label]="'Provider Call Logs'" (pageSizeChange)="onPageSizeChange($event)" />
        </div>
        <table class="table table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="col-1">DATE CALLED</th>
              <th class="col-1">CALLED BY</th>
              <th class="col-2">CALL OUTCOME</th>
              @if (provider) {
                <th class="col-3">OFFICE</th>
              }
              @if (office) {
                <th class="col-3">PROVIDER</th>
              }
              <th class="col-2">PHONE</th>
              <th class="col-3">NOTES</th>
            </tr>
          </thead>
          <tbody>
            @for (providerCallLog of providerCallLogs; track providerCallLog) {
              <tr>
                <td>{{ providerCallLog.createdAt | date: 'M/d/yyyy h:mm a' }}</td>
                <td>{{ providerCallLog.calledBy?.fullName }}</td>
                <td>{{ providerCallLog.callOutcome }}</td>
                @if (provider) {
                  <td>
                    <app-office [office]="providerCallLog.office" />
                    @if (!providerCallLog.office) {
                      <p class="red-cell" >Unknown</p>
                    }
                  </td>
                }
                @if (office) {
                  <td>
                    @if (providerCallLog.provider) {
                      <div>{{ providerCallLog.provider.fullName }}</div>
                      NPI:
                      <a target="_blank" href="/capture-admin/providers/{{providerCallLog.provider.npi}}">
                        {{ providerCallLog.provider.npi }}
                      </a>
                      <a target="_blank" href="/capture-admin/providers/{{ providerCallLog.provider.npi }}">
                        <fa-icon [icon]="['fas', 'external-link-alt']" size="sm" />
                      </a>
                      <app-copy-to-clipboard [text]="providerCallLog.provider.npi" />
                    } @else {
                      <div>UNKNOWN</div>
                    }
                  </td>
                }
                <td [ngClass]="highlightPhone(providerCallLog.enteredPhone, providerCallLog.office?.phone)">
                  <app-phone-number [number]="providerCallLog.enteredPhone || providerCallLog.office?.phone" [noValue]="' '" />
                </td>
                <td [innerHtml]='providerCallLog.notes | safeHtml'></td>
              </tr>
            }
          </tbody>
        </table>
        <div class="mt-2">
          <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
        </div>
      </div>
    }
  </div>
} @else {
  <p class="ms-2">No provider call logs.</p>
}
